/**
 * Haversine distance between two lat/lng points in kilometers.
 * Matches the implementation in laadplein-ocm-competitors edge function.
 */
export function haversineKm(
  lat1: number, lon1: number,
  lat2: number, lon2: number
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(R * c * 10) / 10; // 100m precision
}

/**
 * Find nearest item from a list by coordinates.
 * Returns { item, distance } or null if list is empty or point has no coords.
 */
export function findNearest<T extends { latitude?: number | null; longitude?: number | null }>(
  lat: number, lon: number,
  items: T[]
): { item: T; distance: number } | null {
  let best: { item: T; distance: number } | null = null;

  for (const item of items) {
    if (item.latitude == null || item.longitude == null) continue;
    const d = haversineKm(lat, lon, item.latitude, item.longitude);
    if (!best || d < best.distance) {
      best = { item, distance: d };
    }
  }

  return best;
}
